require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es6.array.species.js
// module id = 157
// module chunks = 0